
import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import draggable from 'vuedraggable';

import ComEmpty from '@/components/com-jzx-empty.vue';
import SelectTheClass from '../views/index/components/select-the-class.vue';

const customLecturesDialogModule = namespace('customLecturesDialog');

const title1: string = '用于面授场景，可对课程要讲的课件及题目内容进行自定义';
const title2: string = 'AI视频教学场景，不能对AI视频进行编辑';
const title3: string = '学生自主练题场景，不能对题目进行编辑';

interface CheckedKeys {
  checked: any[];
  halfChecked: [];
}

@Component({
  components: {
    SelectTheClass,
    draggable,
    ComEmpty,
  },
  filters: {
    teachingScene(val: number) {
      return ['老师教', 'AI课', '自由练'][val];
    },
    filterBtnString(val: number) {
      return val !== 0 ? '查看' : '去备课';
    },
    filterTextString(val: number) {
      return val !== 0 ? '已讲' : '删除';
    },
  },
})
export default class CustomLecturesDialog extends Vue {
  // 获取当前班级信息
  @customLecturesDialogModule.Getter('getCurrentClass') currentClass: any

  // 弹窗显示状态
  @customLecturesDialogModule.Getter('getVisible') visible!: boolean

  // 更新弹窗是否显示
  @customLecturesDialogModule.Mutation('updateVisible') updateVisible: any

  private treeData: any[] = []

  private replaceFields: any = {
    title: 'name',
    key: 'id',
  }

  get btnString() {
    return this.lastIndex === this.activeLineIndex ? '创建讲次' : '修改讲次';
  }

  get cancelString() {
    return this.lastIndex === this.activeLineIndex ? '取消创建' : '取消修改';
  }

  get lastIndex() {
    return this.customLessonList.length;
  }

  get dragOptions() {
    return {
      animation: 600,
      group: 'description',
      disabled: false,
      ghostClass: 'ghost',
      // chosenClass: 'chosen',
      dragClass: 'chosen',
    };
  }

  get radioOptions() {
    return [{ value: 1, label: '老师教', title: title1 }, { value: 2, label: 'AI课', title: title2 }, { value: 3, label: '自由练', title: title3 }];
  }

  get getDelTitle() {
    return `删除第${this.delIndex + 1}讲`;
  }

  /**
   * @description: 创建讲次的禁用状态 根据选中节点和讲次名称判断
   * @param {*}
   * @return {*}
   */
  get createBtnDis() {
    return !this.glxSections.concat(this.axxsections).length || !this.lessonName.length;
  }

  private drag: boolean = false;

  private delVisible: boolean = false;

  // 选中的行下标
  private activeLineIndex: number = -1;

  // 自定义讲次列表
  private customLessonList: any[] = [];

  // 选中的树节点
  private checkedKeys: any[] = [];

  // 输入的讲次名称
  private lessonName: string = ''

  // 授课场景
  private lessonType: number = 1

  // 展示创建讲次页面
  private showKowledgePage: boolean = false

  // 选中的tab
  private activeKey: number = 1

  private tabs: Record<string, any>[] = [{ key: 1, name: '爱学习课件' }, { key: 2, name: '公立校课件' }]

  // 删除的下标
  private delIndex = -1;

  // 需要编辑的讲次行
  private currentLeassonLine: any = {}

  private heightWindow: any = window.innerHeight;

  /**
   * @description: 拖拽移动时 禁止拖动到status为1,2的对象
   * @param {*} e
   * @return {*}
   */
  private onMove(e: any) {
    // e.dragged.querySelector('.iconCustom').style.display = 'inline-block';
    if ([1, 2].includes(e.relatedContext.element.status)) return false;
    return true;
  }

  @Watch('visible')
  async handleLessonDialogChange(newVal: boolean) {
    if (newVal) {
      await this.getCoursewareList();
      await this.getCoustomList();
      this.$nextTick(() => {
        const ele: HTMLElement = document.querySelector('.createList') as HTMLElement;
        ele.scrollTop = 1000000000;
        // const ele = document.querySelector('.createList');
        // if (ele) {
        //   ele.scrollTop = 10000000000;
        // }
      });
    }
  }

  @Watch('allLength')
  comName() {
    if (this.allLength === 0) {
      this.lessonName = '';
      // this.checkedKeys = [];
      // this.expandedKeys = [];
    }
  }

  get fromPad() {
    return this.$route.query.fromPad;
  }

  get widthStyle() {
    return this.fromPad ? '100%' : 1366;
  }

  get className() {
    return this.fromPad || this.heightWindow < 856 ? 'LecturesListModal padClassWrap' : 'LecturesListModal';
  }

  get allLength() {
    return this.axxsections.concat(this.glxSections).length;
  }

  /**
   * @description: 删除爱学习知识点
   * @param {*} idx
   * @return {*}
   */
  private delAxx(idx: number) {
    this.axxsections.splice(idx, 1);
    if (this.activeKey === 1) {
      this.checkedKeys = Array.from(new Set(this.axxsections.map((child: any) => child.id)));
    }
  }

  /**
   * @description: 删除公立校知识点
   * @param {*} idx
   * @return {*}
   */
  private delGlx(idx: number) {
    this.glxSections.splice(idx, 1);
    if (this.activeKey === 2) {
      this.checkedKeys = Array.from(new Set(this.glxSections.map((child: any) => child.id)));
    }
  }

  /**
   * @description: 清空
   * @param {*}
   * @return {*}
   */
  private clearKnowLedge() {
    this.checkedKeys = [];
    this.axxsections = [];
    this.glxSections = [];
    this.expandedKeys = [];
  }

  /**
   * @description: 添加埋点
   * @param {*}
   * @return {*}
   */
  private changeRadio() {
    const map: any = [
      '',
      'id-3',
      'id-4',
      'id-5',
    ];
    this.$utils.sendAction('fromPad', 'index', map[this.lessonType]);
  }

  /**
   * @description: 获取课件
   * @param {*}
   * @return {*}
   */
  private async getCoursewareList() {
    try {
      const result: any = await this.$service.bk.getCoursewareList({
        classId: this.currentClass.id,
        courseType: this.activeKey,
      });
      this.treeData = result;
    } catch (error) {
      this.treeData = [];
    }
  }

  /**
   * @description: 查询自定义讲次
   * @param {*}
   * @return {*}
   */
  private async getCoustomList() {
    try {
      const result: any = await this.$service.bk.getCoustomList({
        classId: this.currentClass.id,
      });
      this.customLessonList = result;
    } catch (error) {
      this.customLessonList = [];
    }
  }

  private draggStart() {
    this.drag = true;
  }

  /**
   * @description: 拖拽结束事件
   * @param {*}
   * @return {*}
   */
  private async draggableEnd(val: any) {
    if (val.newIndex === val.oldIndex) return;
    try {
      await this.changeLesson('排序成功', {
        id: Number(val.item.getAttribute('dataId')),
        number: val.newIndex + 1,
      });
    } catch (error) {
      this.getCoustomList();
    }
    this.drag = false;
    this.$utils.sendAction('fromPad', 'index', 'id-8');
  }

  /**
   * @description: 删除讲次
   * @param {*}
   * @return {*}
   */
  private async hideDelModal() {
    await this.changeLesson(`已成功删除第${this.delIndex + 1}讲`, {
      deleted: 1,
      id: this.currentDelLine.id,
    });
    this.delVisible = false;
  }

  /**
   * @description: 跳转
   * @param {*} item
   * @return {*}
   */
  private jump(item: any) {
    if (item.status !== 0) {
      this.$utils.sendAction('fromPad', 'index', 'id-10');
    } else {
      this.$utils.sendAction('fromPad', 'index', 'id-11');
    }
    if (item.history === 1) {
      const text1 = '数据升级，已开课的讲次不支持查看';
      const text2 = '数据升级，暂不能备课，请重新创建讲次';
      const text = item.status === 0 ? text2 : text1;
      this.$message.warning(text);
      return;
    }
    const router: any[] = ['', 'kejian', 'aivideo', 'selfTrain'];
    const href: string = `${process.env.VUE_APP_JUMPURL}/jzxCourseInfo.html#/${router[item.teachingScene]}?classId=${this.currentClass.id}&lessonId=${item.id}&courseType=${item.teachingScene}&teachingScene=${item.teachingScene}&className=${this.currentClass.name}`;
    if (this.fromPad) {
      window.location.href = href;
    } else {
      window.open(href);
    }
  }

  // 删除行
  private currentDelLine: any = {};

  /**
   * @description: 删除
   * @param {*} item
   * @param {*} index
   * @return {*}
   */
  private del(item: any, index: number) {
    if (item.status !== 0) return;
    this.delVisible = true;
    this.delIndex = index;
    this.currentDelLine = item;
    this.$utils.sendAction('fromPad', 'index', 'id-12');
  }

  /**
   * @description: 取消修改/创建
   * @param {*}
   * @return {*}
   */
  private cancelLesson() {
    // this.activeKey = 1;
    this.restParams();
  }

  /**
   * @description: 初始化状态
   * @param {*}
   * @return {*}
   */
  private restParams() {
    // 隐藏讲次页面
    this.showKowledgePage = false;
    // 讲次名称
    this.lessonName = '';
    // 选中的节点
    this.checkedKeys = [];
    // 重置讲次类型
    this.lessonType = 1;
    // 行高亮
    this.activeLineIndex = -1;
    // 缓存的爱学习子父节点数据
    this.axxsections = [];
    // 缓存的公立校子父节点数据
    this.glxSections = [];
    // 选中的行
    this.currentLeassonLine = {};
  }

  /**
   * @description: 弹窗关闭
   * @param {*}
   * @return {*}
   */
  private handleCancel() {
    if (this.fromPad) {
      window.location.href = `https://bsk.aixuexi.com/jzx/pageDetails?id=${this.currentClass.id}&className=${this.currentClass.name}`;
    }
    this.updateVisible(false);
    // 初始选中tab
    this.activeKey = 1;
    this.restParams();
    this.expandedKeys = [];
  }

  private customPadBack() {
    this.visible = false;
    this.handleCancel();
  }

  /**
   * @description: 切换tab 缓存爱学习课件选中的类型
   * @param {*} key
   * @return {*}
   */
  private async changeClassList(key: number) {
    this.activeKey = key;
    this.checkedKeys = [];
    this.expandedKeys = [];
    await this.getCoursewareList();
    if (this.activeKey === 2) {
      this.checkedKeys = Array.from(new Set(this.glxSections.map((child: any) => child.id)));
      this.$utils.sendAction('fromPad', 'index', 'id-2');
    } else {
      this.checkedKeys = Array.from(new Set(this.axxsections.map((child: any) => child.id)));
      this.$utils.sendAction('fromPad', 'index', 'id-1');
    }
    this.getExpandKeys();
    this.autoExpandParent = true;
  }

  /**
   * @description: 添加讲次
   * @param {*} idx
   * @return {*}
   */
  private addLesson() {
    this.activeLineIndex = this.lastIndex;
    this.showKowledgePage = true;
    this.lessonName = '';
    this.lessonType = 1;
    this.axxsections = [];
    this.glxSections = [];
    this.checkedKeys = [];
    this.expandedKeys = [];
    this.$utils.sendAction('fromPad', 'index', 'id-13');
  }

  private expandedKeys: any[] = [];

  private autoExpandParent: boolean = true;

  /**
   * @description:
   * @param {*} idx
   * @param {*} item
   * @return {*}
   */
  private async editLesson(idx: number, item: any) {
    if (item.status !== 0) return;
    this.activeLineIndex = idx;
    this.currentLeassonLine = item;
    this.lessonName = item.name;
    this.lessonType = item.teachingScene;
    this.showKowledgePage = true;
    this.activeKey = 1;
    await this.getCoursewareList();
    try {
      const result: any = await this.$service.bk.getKnowledgeParentList({
        lessonId: item.id,
      });
      // this.checkedKeys = {
      //   checked: Array.from(new Set(result.axxKnowledgeParentList.concat(result.publicKnowledgeParentList).map((child: any) => child.parentId))),
      //   halfChecked: [],
      // };
      this.checkedKeys = Array.from(new Set(result.axxKnowledgeParentList?.map((child: any) => child.knowledgeId)) || []);
      this.axxsections = result.axxKnowledgeParentList?.map((axx: any) => ({
        id: axx.knowledgeId, parentId: axx.parentId, courseType: 1, name: axx.name,
      })) || [];
      this.glxSections = result.publicKnowledgeParentList?.map((glx: any) => ({
        id: glx.knowledgeId, parentId: glx.parentId, courseType: 2, name: glx.name,
      })) || [];
      this.expandedKeys = [];
      this.getExpandKeys();
    } catch (error) {
      this.axxsections = [];
      this.glxSections = [];
      this.checkedKeys = [];
      this.$message.error(error.message);
    }
    this.autoExpandParent = true;
    this.$utils.sendAction('fromPad', 'index', 'id-9');
  }

  /**
   * @description: 深度优先遍历获取默认展开的父节点
   * @param {*} root
   * @return {*}
   */
  private dfs(root: any) {
    if (root.disableCheckbox === false && this.checkedKeys.includes(root.id)) {
      this.expandedKeys.push(root.parentId);
    }
    if (!root.children) return;
    root.children.forEach(this.dfs);
  }

  /**
   * @description: 获取默认展开的父节点
   * @param {*}
   * @return {*}
   */
  private getExpandKeys() {
    this.treeData.forEach((root: any) => {
      this.dfs(root);
    });
    this.expandedKeys = Array.from(new Set(this.expandedKeys));
  }

  private onExpand(expandedKeys: any) {
    this.expandedKeys = expandedKeys;
    this.autoExpandParent = false;
  }

  // 存储父节点子节点ID
  private axxsections: any[] = [];

  private glxSections: any[] = [];

  /**
   * @description: 选中树节点的回调
   * @param {*} checkedKeys
   * @return {*}
   */
  private onCheck(checkedKeys: any, e: any) {
    if (this.lessonName === '') {
      this.lessonName = e.checkedNodes[0].data.props.name;
    }
    if (this.activeKey === 1) {
      this.axxsections = [];
    } else {
      this.glxSections = [];
    }
    e.checkedNodes.forEach((item: any) => {
      const obj = item.data.props.knowledge;
      if (obj) {
        const param: any = {
          id: obj.knowledgeId,
          parentId: item.data.props.parentId,
          courseType: this.activeKey,
          name: item.data.props.name,
        };
        if (this.activeKey === 1) {
          this.axxsections.push(param);
        } else {
          this.glxSections.push(param);
        }
      }
    });
    this.checkedKeys = checkedKeys;
    // if (this.activeLineIndex === this.lastIndex && e.checkedNodes.length === 1) {
    //   const arr: any[] = e.checkedNodes[0].data.props.name.split(' ');
    //   this.lessonName = arr.length > 1 ? arr[1] : arr[0];
    //   // this.lessonName = e.node.title..split(' ')
    //   if (this.activeKey === 1) this.cacheAxxName = this.lessonName;
    //   else this.cacheGlxName = this.lessonName;
    // }
  }

  /**
   * @description: 新增修改 公共参数
   * @param {*}
   * @return {*}
   */
  private getParams() {
    const allArr: any[] = this.axxsections.concat(this.glxSections);
    const uniqArr: any[] = [];
    allArr.forEach((item) => {
      if (!uniqArr.find((uniq) => uniq.id === item.id)) {
        uniqArr.push(item);
      }
    });
    return {
      classId: this.currentClass.id, // 班级ID
      // courseType: this.activeKey, // 课程类型
      teachingScene: this.lessonType, // 教学场景
      lessonName: this.lessonName, // 讲次名称
      number: this.lastIndex + 1, // 讲次序号
      sections: uniqArr, // 选中知识点下面的知识源
    };
  }

  /**
   * @description: 创建讲次
   * @param {*}
   * @return {*}
   */
  private async createLesson() {
    if (this.activeLineIndex === this.lastIndex) {
      try {
        await this.$service.bk.addCustomLesson(this.getParams());
        this.restParams();
        this.$message.success(`已成功创建第${this.lastIndex + 1}讲`);
        this.expandedKeys = [];
        await this.getCoustomList();
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$utils.sendAction('fromPad', 'index', 'id-6');
    } else {
      await this.changeLesson(`已成功修改第${this.activeLineIndex + 1}讲`, { id: this.currentLeassonLine.id, ...this.getParams(), number: this.activeLineIndex + 1 });
      this.expandedKeys = [];
      this.$utils.sendAction('fromPad', 'index', 'id-7');
    }
  }

  /**
   * @description: 修改/排序/删除
   * @param {*}
   * @return {*}
   */
  private async changeLesson(message: string, params: any) {
    try {
      await this.$service.bk.changeLesson({
        ...params,
      });
      this.restParams();
      this.$message.success(message);
      await this.getCoustomList();
    } catch (error) {
      this.$message.error(error.message);
      throw new Error();
    }
  }

  mounted() {
    window.onresize = () => {
      this.heightWindow = window.innerHeight;
    };
  }

  beforeDestroy() {
    window.onresize = null;
  }
}
